import { tiles } from '@tahi/db';
import { and, asc, eq, isNull } from 'drizzle-orm';
import type { TileRow } from '../../tiles/layout';
import type { LocalDb } from '../localDb';

export function listTiles(
  db: LocalDb,
  dashboardId: string,
  opts: { includeDeleted?: boolean } = {},
): Promise<TileRow[]> {
  const where = opts.includeDeleted
    ? eq(tiles.dashboardId, dashboardId)
    : and(eq(tiles.dashboardId, dashboardId), isNull(tiles.deletedAt));
  return db.select().from(tiles).where(where).orderBy(asc(tiles.position)).all();
}
